.cell-label {
  display: inherit;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--body-size-medium);
  line-height: 1;
  font-family: var(--font-family-secondary);

  &--header {
    font-family: var(--font-family);
    font-size: var(--body-size);
    color: var(--body-text-arrows-400);
  }
}

:host {
  --grid-row-hover-background: transparent;
}

vaadin-grid {
  background-color: var(--grid-row-hover-background);
  min-width: var(--grid-min-width, unset);
}

vaadin-grid-cell-content {
  color: var(--body-text-arrows-400);
}

vaadin-grid::part(cell) {
  background: var(--grid-row-hover-background);
}
